const routesNames = {
    STATIC_PAGE: 'static_content',
    GAME_LOBBY: 'lobby',
    GAME_LOBBY_SHORT: 'lobby_short',

    HELP_CATEGORY: 'help_category',
    HELP_ITEM: 'help_item',

    REGISTRATION_PAGE: 'registration_page',
    LOGIN_PAGE: 'login_page',

    USER_VERIFY_IDENTITY: 'userVerifyIdentity',
    USER_COMPLETE_SIGNUP: 'userCompleteSignup',
    USER_TRANSACTION_HISTORY: 'userTransactionHistory',
    USER_RESET_PASSWORD: 'userResetPassword',
    USER_ACCOUNT: 'userAccount',
    USER_BONUSES: 'userBonuses',
    USER_VIP_POINTS: 'userVipPoints',
    USER_LIMITS: 'userLimits',
    USER_REWARDS: 'userRewards',
    USER_TOURNAMENTS: 'userTournaments',
    USER_SELF_EXCLUSION: 'userSelfExclusion',
    USER_TWO_FACTOR_AUTH: 'twoFactorAuth',

    SERVICE_UNAVAILABLE: 'serviceUnavailable',
    PAGE_NOT_FOUND: 'notFound',
    PAGE_HAS_NOT_TRANSLATION: 'noTranslation',
};

const routesPaths = {
    [routesNames.USER_RESET_PASSWORD]: '/user/reset-password',
    [routesNames.USER_ACCOUNT]: '/user/account',
    [routesNames.USER_BONUSES]: '/user/bonuses',
    [routesNames.USER_TRANSACTION_HISTORY]: '/user/transaction_history',
    [routesNames.USER_VIP_POINTS]: '/user/vip_points',
    [routesNames.USER_VERIFY_IDENTITY]: '/user/verify_identity',
    [routesNames.USER_COMPLETE_SIGNUP]: '/user/complete-signup',
    [routesNames.USER_LIMITS]: '/user/limits',
    [routesNames.USER_REWARDS]: '/user/rewards',
    [routesNames.USER_TOURNAMENTS]: '/user/tournaments',
    [routesNames.USER_SELF_EXCLUSION]: '/user/self-exclusion',
    [routesNames.USER_TWO_FACTOR_AUTH]: '/user/two-factor-auth',
    [routesNames.SERVICE_UNAVAILABLE]: '/error/503',
    [routesNames.PAGE_NOT_FOUND]: '/error/404',
    [routesNames.PAGE_HAS_NOT_TRANSLATION]: '/error/no-translation',
}

const luckyWheelExcludedRoutes = [
    routesNames.SERVICE_UNAVAILABLE,
    routesNames.PAGE_NOT_FOUND,
    routesNames.PAGE_HAS_NOT_TRANSLATION,
    routesNames.GAME_LOBBY,
    routesNames.GAME_LOBBY_SHORT,
    routesNames.USER_VERIFY_IDENTITY,
    routesNames.USER_COMPLETE_SIGNUP,
    routesNames.USER_TRANSACTION_HISTORY,
    routesNames.USER_RESET_PASSWORD,
    routesNames.USER_ACCOUNT,
    routesNames.USER_BONUSES,
    routesNames.USER_VIP_POINTS,
    routesNames.USER_LIMITS,
    routesNames.USER_REWARDS,
    routesNames.USER_TOURNAMENTS,
    routesNames.USER_SELF_EXCLUSION,
    routesNames.USER_TWO_FACTOR_AUTH,
    routesNames.HELP_CATEGORY,
    routesNames.HELP_ITEM,
];

const eventExcludedRoutes = [
    routesNames.SERVICE_UNAVAILABLE,
    routesNames.PAGE_NOT_FOUND,
    routesNames.PAGE_HAS_NOT_TRANSLATION,
    routesNames.USER_VERIFY_IDENTITY,
    routesNames.USER_COMPLETE_SIGNUP,
    routesNames.USER_TRANSACTION_HISTORY,
    routesNames.USER_RESET_PASSWORD,
    routesNames.USER_ACCOUNT,
    routesNames.USER_BONUSES,
    routesNames.USER_VIP_POINTS,
    routesNames.USER_LIMITS,
    routesNames.USER_REWARDS,
    routesNames.USER_TOURNAMENTS,
    routesNames.USER_SELF_EXCLUSION,
    routesNames.USER_TWO_FACTOR_AUTH,
    routesNames.HELP_CATEGORY,
    routesNames.HELP_ITEM,
];

const footerExcludedRoutes = [
    routesNames.SERVICE_UNAVAILABLE,
    routesNames.PAGE_NOT_FOUND,
    routesNames.PAGE_HAS_NOT_TRANSLATION,
    routesNames.GAME_LOBBY,
    routesNames.GAME_LOBBY_SHORT,
];

module.exports = {
    routesNames,
    routesPaths,
    luckyWheelExcludedRoutes,
    eventExcludedRoutes,
    footerExcludedRoutes,
};